<template>
  <v-dialog v-model="verifyToShipForm" no-click-animation persistent max-width="400">
    <v-card>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-title class="headline primary white--text">Verify To Ship</v-card-title>
        <v-card-text class="mt-20">
          <dynamic-form
            :watchKey="verifyToShipForm"
            :fieldGroups="verifyToShipFields"
            :bindObj="verifyToShipObj"
            :split="false"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="discard" class="white--text" color="primary" depressed> Discard </v-btn>
          <v-btn
            @click="submit"
            class="white--text"
            color="primary"
            :disabled="invalid || processing"
            depressed
          >
            Submit
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import verifyToShipFields from '@/models/verify-to-ship-form';

export default {
  name: 'VerifyToShipForm',
  data() {
    return { processing: false };
  },
  computed: {
    ...mapState('loadApproval', ['verifyToShipForm']),
    verifyToShipFields: () => verifyToShipFields,
    verifyToShipObj: {
      get: () => store.state.loadApproval.verifyToShipObj,
      set: v => store.commit('loadApproval/setVerifyToShipObj', v)
    },
    verifyToShipForm: {
      get: () => store.state.loadApproval.verifyToShipForm,
      set: v => store.commit('loadApproval/setVerifyToShipForm', v)
    }
  },
  methods: {
    ...mapMutations('loadApproval', ['setVerifyToShipForm']),
    ...mapActions('loadApproval', ['verifyToShip']),
    async submit() {
      try {
        this.processing = true;
        await this.verifyToShip();
      } finally {
        this.processing = false;
        this.discard();
      }
    },
    discard() {
      this.setVerifyToShipForm(false);
      const { observer } = this.$refs;
      if (observer) observer.reset();
      this.verifyToShipObj.pin = null;
      this.verifyToShipObj.sonum = null;
    }
  },
  mounted() {
    this.verifyToShipObj.sonum = this.sonum;
  },
  props: {
    sonum: {
      type: Number,
      required: true
    }
  }
};
</script>
